import { render, staticRenderFns } from "./WhoIsOnboard.vue?vue&type=template&id=2d9c3486&scoped=true&"
import script from "./WhoIsOnboard.vue?vue&type=script&lang=js&"
export * from "./WhoIsOnboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d9c3486",
  null
  
)

export default component.exports